(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactProcess', {
        templateUrl: 'views/components/views/custactProcess/custactProcess.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'custactProcessService', function ($stateParams, stateService, translateService, modalService, custactProcessService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactNo = $stateParams.custact_no;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                itemsListProcesses: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadProcesses() {
                vm.model.itemsListProcesses = (await custactProcessService.listProcesses({ custact_no: custactNo }));
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region TOGGLE FUNCTION

            vm.toggleChosen = function (item) {
                item = item?.item ? item.item : item;
                
                if (item.item_id === '0' || item.item_id === '-1') return;
                
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #endregion TOGGLE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                let selectedItems = [];

                vm.model.itemsListProcesses.forEach((item) => {
                    selectedItems.push({
                        item_id: item.item_id,
                        item_is_selected: item.item_is_selected
                    });
                }); 

                custactProcessService.saveObj({
                    custact_no: custactNo,
                    records: selectedItems
                }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadProcesses();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
